interface CSVData {
  date: any;
  price: number;
}

export const processCSVData = (
  csvData: number[],
  type?: any,
  key?: any
): CSVData[] => {
  if (!csvData || csvData.length === 0) {
    return [];
  }
  const keepaMinutesToDate = (keepaMinutes: number): Date => {
    const epochTime = (keepaMinutes + 21564000) * 60000;
    return new Date(epochTime);
  };

  const testData: CSVData[] = [];
  for (let i = 0; i < csvData?.length; ) {
    const date = keepaMinutesToDate(csvData[i]);
    const price = (() => {
      if (type === "rating") {
        return csvData[i + 1] / 10;
      } else if (type === "ReviewCount") {
        return csvData[i + 1];
      } else if (type) {
        return csvData[i + 1];
      } else {
        return csvData[i + 1] / 100;
      }
    })();
    if (price > 0) {
      testData.push({ date, price });
    }
    if (key !== "buyBoxData") {
      i += 2;
    } else {
      i += 3;
    }
  }
  return testData;
};

const addDummyValue = (
  data: any[],
  timestamp: number,
  previousValue: number | null
): void => {
  const dummyValue: [number, number | null] = [timestamp - 1, previousValue];
  if (!data[data.length - 1]) {
    data[data.length - 1] = [];
  }
  data[data.length - 1].push(dummyValue);
};

const updateTimestamps = (
  value: [number, number | null],
  latestTimestamp: number,
  earliestTimestamp: number
): { latestKeepaTimestamp: number; earliestKeepaTimestamp: number } => {
  const [timestamp] = value;
  latestTimestamp = Math.max(latestTimestamp, timestamp);
  earliestTimestamp =
    earliestTimestamp === -1
      ? timestamp
      : Math.min(earliestTimestamp, timestamp);
  return {
    latestKeepaTimestamp: latestTimestamp,
    earliestKeepaTimestamp: earliestTimestamp,
  };
};

const addTransformedValues = (
  data: any[],
  value: [number, number | null]
): void => {
  const prev: any = data.length ? [...data[data.length - 1]] : [...value];
  prev[0] = value[0] - 1;
  data.push(prev);
  data.push(value);
};

const getFinalValue = (
  rawValue: number | null | undefined,
  key: string
): number | null => {
  rawValue = rawValue ?? 0;
  rawValue = rawValue <= 0 ? -1 : rawValue;
  let finalValue: any = rawValue <= 0 ? null : rawValue;

  if (key === "RATING") {
    finalValue = finalValue / 10;
  }
  return finalValue;
};

const keepaTimeToUnixDateTime = (keepaMinutes: number): number => {
  return (keepaMinutes + 21564000) * 60000;
};
export const transformKeepaCsv = (keepaCsv: any[], key: string): any[] => {
  const transformedKeepaData: any[] = [];
  let lMinTimestamp = 0;
  let latestKeepaTimestamp = -1;
  let earliestKeepaTimestamp = -1;
  let previousFinalValue: number | null = 0;

  if (!keepaCsv) return transformedKeepaData;

  for (let i = 0; i < keepaCsv.length; i += 2) {
    const lUnixDateTime = keepaTimeToUnixDateTime(keepaCsv[i]);
    if (lUnixDateTime < lMinTimestamp) continue;

    const finalValue = getFinalValue(keepaCsv[i + 1], key);
    if (finalValue === null) {
      addDummyValue(transformedKeepaData, lUnixDateTime, previousFinalValue);
    }

    const transformedValue: [number, number | null] = [
      lUnixDateTime,
      finalValue,
    ];
    ({ latestKeepaTimestamp, earliestKeepaTimestamp } = updateTimestamps(
      transformedValue,
      latestKeepaTimestamp,
      earliestKeepaTimestamp
    ));

    addTransformedValues(transformedKeepaData, transformedValue);
    previousFinalValue = finalValue;
  }

  return transformedKeepaData;
};
